import type { Patient, Reference } from '@medplum/fhirtypes'
import {
  ORDER_CATEGORY_CODE_SYSTEM,
  OrderCategory,
} from '#src/models/orders/constants.ts'
import { Order } from '#src/models/orders/Order.ts'
import type { QueryTypes } from '#src/search.ts'

export class ReferralOrder extends Order {
  static readonly searchCode = `${ORDER_CATEGORY_CODE_SYSTEM}|${OrderCategory.Specialist}`

  static activeSearchQuery(): QueryTypes {
    return {
      category: ReferralOrder.searchCode,
      'status:not': 'revoked,draft',
    }
  }

  static byParticipant(params: {
    participant: Reference<Patient>
  }): QueryTypes {
    return {
      ...this.activeSearchQuery(),
      patient: params.participant,
      _sort: '-_lastUpdated',
      _count: '100',
    }
  }
}
